import axios from 'axios';

export default {
    async turn_around(payload) {
        let { data } = await axios.get(`${process.env.VUE_APP_API_URL}turns/turn_around`, {
            params: {...payload}
        });
        return data
    },

    async get_turn(payload) {
        let { data } = await axios.get(`${process.env.VUE_APP_API_URL}turns/get`, {
            params: {token: payload.token}
        });
        return data
    },

    async get_histories(payload) {
        let { data } = await axios.get(`${process.env.VUE_APP_API_URL}turns/histories`, {
            params: {token: payload.token}
        });
        return data
    }
}